import copy from 'copy-to-clipboard'
import * as React from 'react'

export function useCopyToClipboard() {
  const timeout = React.useRef<number | undefined>(undefined)
  const [isCopied, setIsCopied] = React.useState(false)

  React.useEffect(() => () => clearTimeout(timeout.current), [])

  return React.useMemo(
    () => ({
      isCopied,
      handleCopy: (text: string) => {
        copy(text)
        setIsCopied(true)
        clearTimeout(timeout.current)
        timeout.current = window.setTimeout(() => {
          setIsCopied(false)
        }, 2000)
      },
    }),
    [isCopied]
  )
}
